module.exports = __webpack_public_path__ + "img/Jump Casting105.530285e4.jpg";